import { defaults } from './defaults';

export default defaults;
